import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon  } from 'mdbreact';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
//import Modalarticletyps from './Modalarticletypes';




export default class superadminlistregister extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[]
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
            Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectregister.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {
        return (
            <MDBContainer>
            <div>
        
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
            <p className="text-right">การประชุมวิชาการระดับชาติครุศาสตร์ศึกษา ครั้งที่ 8 มหาวิทยาลัยราชภัฏกำแพงเพชร</p> 
         
               <MDBAlert color="success" >
                   <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ลงทะเบียน</h2>
                </MDBAlert>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อ-นามสกุล</th>
                        <th>เบอร์โทร</th>
                        <th>อีเมลล์</th>
                       
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.register_pname}{article.register_nameth} {article.register_lnameth}</td>
                        <td>{article.register_phone}</td>
                        <td>{article.register_email}</td>
                       
                        
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable>

            </div>
            </MDBContainer>
        )
    }
}
